<template>
  <CommonVCard id="profile" customClassName="pb-10">
    <h3 class="registration-form__subheader mb-2">
      {{ $t("player_registration.player_profile") }}
    </h3>

    <div v-if="isRenderPlayerProfile">
      <CommonPlayerProfileFormField
        v-for="field in playerProfileForm"
        :id="field.id"
        :key="field.name"
        :changeFormField="handleChangeFormField"
        :currentlyLoggedUserFullName="currentlyLoggedUserFullName"
        :description="field.description"
        :disabled="disabled"
        :fieldValue="mustUpdate(field) ? null : field.value"
        :isFormValidated="isFormValidated"
        :items="field.items"
        :label="field.label"
        :medium="field.medium"
        :name="field.name"
        :numberEntry="field.numberEntry"
        :optional="field.optional"
        :rules="field.rules"
        :small="field.small"
        :type="field.type"
      />
      <span class="grey--text">* required fields</span>
    </div>
    <div v-else class="d-flex justify-center mt-4">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
  </CommonVCard>
</template>

<script>
import CommonVCard from "./CommonVCard";
import CommonPlayerProfileFormField from "./CommonPlayerProfileFormField";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { mapGetters, mapMutations } from "vuex";
import { RegistrationAnswerType } from "../enums/AnswerType";
import {
  RegistrationQuestionsAddressFields,
  RegistrationQuestionsTitleAdminContext
} from "../enums/RegistrationQuestionsTitle";

export default {
  name: "PlayerRegistrationFormProfileCard",
  components: { CommonPlayerProfileFormField, CommonVCard },
  props: {
    isFormValidated: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    RegistrationAnswerType,
    RegistrationQuestionsTitleAdminContext
  }),

  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerProfileForm",
      "playerRegistrationDetails",
      "playerRegistrationDetailsLoader",
      "playerRegistrationInfo"
    ]),

    isRenderPlayerProfile() {
      return (
        this.playerProfileForm?.length && !this.playerRegistrationDetailsLoader
      );
    },

    currentlyLoggedUserFullName() {
      const {
        currentlyLoggedUserFirstName,
        currentlyLoggedUserLastName
      } = this.playerRegistrationInfo;
      return `${currentlyLoggedUserFirstName} ${currentlyLoggedUserLastName}`;
    }
  },

  methods: {
    ...mapMutations(ModuleTypes.PLAYER_REGISTRATION, [
      "setPlayerProfileFormValues"
    ]),

    mustUpdate(field) {
      return (
        (field.name === "Grade" || field.name === "School") && !field.optional
      );
    },

    handleChangeFormField(e, name) {
      this.setPlayerProfileFormValues({
        playerProfileForm: this.playerProfileForm.map(item => {
          if (item.name === name) {
            return {
              ...item,
              value: e
            };
          }
          return item;
        })
      });
    }
  },

  mounted() {
    this.playerProfileForm.forEach(f => {
      if (this.mustUpdate(f)) {
        this.handleChangeFormField("", f.name);
      }
    });
  },

  watch: {
    playerRegistrationDetails: function(newValue) {
      this.setPlayerProfileFormValues({
        playerProfileForm: this.playerProfileForm?.map(question => {
          if (!newValue.playerAnswerList) {
            return question;
          }
          const playerAnswer = newValue.playerAnswerList.find(
            ({ questionId }) => questionId === question.id
          );
          const {
            SECTION_TITLE,
            TEXT_BLOCK,
            FILE_ATTACHMENT,
            OPTIONS_CHOOSE_MULTIPLE
          } = RegistrationAnswerType;
          let value;
          switch (question.type) {
            case SECTION_TITLE || TEXT_BLOCK:
              value = question.name;
              break;
            case FILE_ATTACHMENT:
              value = playerAnswer.fileAttachmentList;
              break;
            case OPTIONS_CHOOSE_MULTIPLE:
              value = playerAnswer.answers;
              break;
            default:
              if (RegistrationQuestionsAddressFields.includes(question.name)) {
                const index = RegistrationQuestionsAddressFields.findIndex(
                  item => item === question.name
                );
                value = playerAnswer.answers?.[index] || "";
              } else {
                value = playerAnswer.answers?.[0] || "";
              }
          }
          return {
            ...question,
            value
          };
        })
      });
      this.playerProfileForm.forEach(f => {
        if (this.mustUpdate(f)) {
          this.handleChangeFormField("", f.name);
        }
      });
    }
  }
};
</script>

<style scoped>
.registration-form__subheader {
  font-size: 18px;
  font-weight: 500;
  color: var(--dark-color);
}
</style>
